module.exports = __webpack_public_path__ + "static/media/reptile.aabbafb8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Helpers/Storage/Images/reptile.svg
// module id = 482
// module chunks = 0